var React = require('react');

function Mic (props) {
    return React.createElement("svg",props,[React.createElement("rect",{"x":"9","y":"3","width":"6","height":"11","rx":"3","fill":"currentColor","key":0}),React.createElement("path",{"d":"M5 11v1a7 7 0 0 0 14 0v-1","stroke":"currentColor","strokeWidth":"1.8","strokeLinecap":"round","fill":"none","key":1}),React.createElement("line",{"x1":"12","y1":"19","x2":"12","y2":"21.5","stroke":"currentColor","strokeWidth":"1.8","strokeLinecap":"round","key":2}),React.createElement("line",{"x1":"8.5","y1":"21.5","x2":"15.5","y2":"21.5","stroke":"currentColor","strokeWidth":"1.8","strokeLinecap":"round","key":3})]);
}

Mic.defaultProps = {"width":"16","height":"16","viewBox":"0 0 24 24","fill":"none"};

module.exports = Mic;

Mic.default = Mic;
